"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandsetParser = void 0;
var _constants = require("../../constants");
class HandsetParser {
  constructor(props) {
    this.metadata = void 0;
    this.metadata = props.metadata;
  }
  showDiscountData() {
    var _this$metadata, _this$metadata$flags;
    return (_this$metadata = this.metadata) === null || _this$metadata === void 0 ? void 0 : (_this$metadata$flags = _this$metadata.flags) === null || _this$metadata$flags === void 0 ? void 0 : _this$metadata$flags[_constants.FLAGS.IS_CUSTOMER];
  }
}
exports.HandsetParser = HandsetParser;